<!-- Tasks tab content -->
<div class="" style="height:100%; padding-bottom:45px;">
  <div class="scroll-detail">

    <!-- asset has no tasks-->
    <div  *ngIf="tasksData.length == 0" class="text-center no-data xxsmall">
      {{'Select.createtask.notaskmsg'|translate}}
    </div>

    <!-- asset has tasks-->
    <div *ngIf="tasksData.length > 0">

      <!-- task cards -->
      <div class="assessment-card" *ngFor="let task of tasksData">

        <div class="task-heading h7 flex-between">

          <!-- lock icon and activity (task card title) -->
          <div class="title" style="display:flex; align-items:end;">
            <mat-icon *ngIf="task.attributes.Status != 'Closed' else ElseBlock" aria-hidden="true" svgIcon="unlock"></mat-icon>
            <ng-template #ElseBlock>
               <mat-icon aria-hidden="true" svgIcon="lock"></mat-icon>
            </ng-template>
            <span>{{(task.attributes.Activity) ? task.attributes.Activity : 'AssetViewerDetail.Task.NoneAvaialble'|translate}}</span>
          </div>

          <!-- edit/delete/complete buttons-->
          <div class="actions" style="display:flex; align-items:end;">
            <mat-icon style="text-align: center;" id="rollback" title="Activity Rollback"
              *ngIf="(this.RollBackObjectID === task.attributes.OBJECTID) && task.attributes.PendingChanges && currentUser.rolePermissions.assessmentEdit && currentUser.soultionTiers[0][0].activity_Rollback && isDataEditor"
              (click)="rollBackAssets(task.attributes)"
              svgIcon="undo"
              aria-hidden="true">
            </mat-icon>
            <!-- TSDRSAM-1856 -->
            <mat-icon title="Edit" *ngIf="currentUser.rolePermissions.taskEditOpen && isDataEditor && (task.attributes.Status == 'Closed') == false" (click)="task.attributes.Status != 'Closed' ? editTask(task.attributes) : false" svgIcon="edit" style="margin-left:10px;"></mat-icon>
            <!-- TSDRSAM-1964 -->
            <mat-icon title="Delete" *ngIf="currentUser.rolePermissions.taskDeleteOpen && isDataEditor && task.attributes.Activity != 'New' && task.attributes.Activity != 'DetailUpdate' && task.attributes.Status != 'Closed'"  (click)="task.attributes.Status != 'Closed' ? deleteTask(task.attributes) : false" svgIcon="delete-nav" style="margin-left:10px;"></mat-icon>
            <mat-icon [title]="task.attributes.Status != 'Closed' ? 'Complete' : 'Task Complete, no action required.'" *ngIf="currentUser.rolePermissions.taskCompleteOpen && isDataEditor && (task.attributes.Status == 'Closed') == false" (click)="task.attributes.Status != 'Closed' ? completeTask(task.attributes) : false" svgIcon="check" style="margin-left:10px;"></mat-icon>
          </div>

        </div>

        <!-- date -->
        <div class="item-spacing ">
          {{task.attributes.CompletionDate !=null ? (task.attributes.CompletionDate | date :'mediumDate') :((task.attributes.LastModifyDate !=null && task.attributes.CompletionDate ==null) ?  (task.attributes.LastModifyDate | date :'mediumDate') :(task.attributes.CreationDate | date :'mediumDate'))}}
        </div>
       
        <!-- closed task attributes -->
        <div *ngIf="task.attributes.Status == 'Closed'">
          <div *ngFor="let field of closedfield">
            <div *ngIf="['CreationDate','CompletionDate','LastModifyDate','SheduledDate','StartTime','EndTime'].indexOf(field) === -1" class="avCardDetailRow">
              <div class="avFormLabel">{{field}}</div>
              <div class="avFormValue">{{task.attributes[field]}}</div>
            </div>
            <div *ngIf="['StartTime','EndTime'].indexOf(field) !== -1" class="avCardDetailRow">
              <div class="avFormLabel">{{field}}</div>
              <div class="avFormValue">{{task.attributes[field]|date: 'HH:mm'}}</div>
            </div>        
            <div *ngIf="['CreationDate','CompletionDate','LastModifyDate','SheduledDate'].indexOf(field) !== -1" class="avCardDetailRow">
              <div class="avFormLabel">{{field}}</div>
              <div class="avFormValue">{{task.attributes[field]|date: 'MM/dd/yyyy'}}</div>
            </div>
          </div>
        </div>

        <!-- open task attributes -->
        <div *ngIf="task.attributes.Status != 'Closed'">
          <div *ngFor="let field of openfield">
            <div *ngIf="['CreationDate','CompletionDate','LastModifyDate','SheduledDate','StartTime','EndTime'].indexOf(field) === -1" class="avCardDetailRow">
              <div class="avFormLabel">{{field}}</div>
              <div class="avFormValue">{{task.attributes[field]}}</div>
            </div>
            <div *ngIf="['StartTime','EndTime'].indexOf(field) !== -1" class="avCardDetailRow">
              <div class="avFormLabel">{{field}}</div>
              <div class="avFormValue">{{task.attributes[field]|date: 'HH:mm'}}</div>
            </div>
            <div *ngIf="['CreationDate','CompletionDate','LastModifyDate','SheduledDate'].indexOf(field) !== -1" class="avCardDetailRow">
              <div class="avFormLabel">{{field}}</div>
              <div class="avFormValue">{{task.attributes[field]|date: 'MM/dd/yyyy'}}</div>
            </div>
          </div>
        </div>

      </div>

    </div>
  </div>
</div>

<!-- task tab footer -->
<div class="sms-form-footer" *ngIf="currentUser.rolePermissions.taskCreateGeneral && isDataEditor">
  <button [ngClass]="{ 'btndisabled': activeAsset[0].DoNotReplace == 1}" [disabled]="(activeAsset[0].DoNotReplace == 1)? true : false" title="{{'Select.task.replacebtn'|translate}}" mat-button  class="h7 primary-button" (click)="addTask('Replace')">{{'Select.task.replacebtn'|translate}}</button>
  <button title="{{'Select.task.retirebtn'|translate}}" mat-button class="primary-button h7" (click)="addTask('Retire')">{{'Select.task.retirebtn'|translate}}</button>
  <button title="{{'Select.task.taskcreatebtn'|translate}}" mat-button class="primary-button h7"  (click)="addTask('General')">{{'Select.task.taskcreatebtn'|translate}}</button>
</div>